import React, { useCallback, useEffect, useState, useMemo } from "react";
import OtpInput from "react-otp-input";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { setLogId } from "../../actions/actions";
import Timer from "../../components/timer";
import { generateOtp, signIn } from "../../services/authServices";
// import { getUserPreferences } from "../../services/userService";
import { useCountdown } from "../../utils/countdown";
import {
  userPreferences,
  setUserDetails,
  setCustomSource,
} from "../../actions/actions";
import { API_URL } from "../../config/config";
import { getHeaderOptions } from "../../services/getHeaderOptions";
import axios from "axios";
import logger, { Logger } from '../../utils/logger';
import { getDeviceInfo } from "../../utils/deviceInfo";
import PostLoginMpinSetup from "../login/PostLoginMpinSetup";
import "../login/onboarding.css";

interface HeapUserData {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  isOnboardCompleted?: boolean;
  subscription?: {
    status: string;
  };
  role?: {
    name: string;
  };
  organization?: {
    name: string;
  };
}

export const OtpVerification = () => {
  const [otp, setOTP] = useState<string>("");
  const [verifying_otp, setVerifyOtp] = useState(false);
  const [otp_verify_error, setOtpVerifyError] = useState(false);
  const [showMpinSetup, setShowMpinSetup] = useState(false);
  const logId = useSelector(
    (state: { rootReducers: { logId: { logId: string } } }) =>
      state?.rootReducers?.logId?.logId
  );
  const currentTime = new Date().getTime();
  const timeAfterOneSecond = currentTime + 1 * 60 * 1000;
  const [minutes, seconds] = useCountdown(timeAfterOneSecond);
  const [flag, setFlag] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
const [buttonCooldown, setButtonCooldown] = useState<number>(0);

  useMemo(() => {
    if (minutes + seconds <= 0) {
      setFlag(true);
    }
  }, [minutes, seconds]);

  function makeId(length: number) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
// Cooldown timer for resend buttons
const startCooldown = () => {
  setIsButtonDisabled(true);
  setButtonCooldown(30);
  
  const countdown = setInterval(() => {
    setButtonCooldown((prev) => {
      if (prev <= 1) {
        clearInterval(countdown);
        setIsButtonDisabled(false);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
};
  /*
  const initHeapUser = (userData: HeapUserData) => {
    if (typeof window.heap === "undefined") {
      setTimeout(() => initHeapUser(userData), 1000);
      return;
    }

    try {
      window.heap.identify(userData._id);
      window.heap.addUserProperties({
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        phone: userData.phone,
        isOnboardCompleted: userData.isOnboardCompleted,
        isSubscriptionActive: userData.subscription?.status === "active",
        userRole: userData.role?.name,
        organization: userData.organization?.name,
      });
      Logger.log("Heap user properties set successfully");
    } catch (error) {
      logger.error("Failed to initialize Heap user:", error);
    }
  };*/

  const handleClick = useCallback(async () => {
   var pattern = /^\d{4}$/;
    if (!pattern.test(otp)) {
      setOtpVerifyError(true);
      Logger.log("[OTP] Invalid OTP format - must be 4 digits");
      return;
    }

    setVerifyOtp(true);
let data = {
  loginType: "phone",
  loggedFrom: "web",
  deviceToken: JSON.parse(localStorage.getItem("fcm_token_data") || "{}").token,
  countryCode: localStorage.getItem("countryCode"),
  phone: localStorage.getItem("phone"),
  otp: otp,
  otpType: "custom_sms_otp",
  deviceInfo: await getDeviceInfo(), 
};

    try {
      Logger.log("[OTP] Sending sign in request with data:", data);
      const response = await signIn(data);

      Logger.log("[OTP] Response received:", {
        hasToken: response?.data?.data?.token ? "Yes" : "No",
        isNewUser: response?.data?.data?.isNewAccount ? "Yes" : "No",
        onboardingCompleted: response?.data?.data?.isOnboardCompleted
          ? "Yes"
          : "No",
        subscriptionActive: response?.data?.data?.isSubscriptionActive
          ? "Yes"
          : "No",
      });

      if (response && response.status) {
        // Store data first
        Logger.log("[OTP] Storing auth data and user details");
        localStorage.setItem("auth_token", response?.data?.data?.token);
        localStorage.setItem("userData", JSON.stringify(response?.data?.data));

        if (response?.data?.data?.multiAccountList?.length) {
          // Store just the multi-business array
          logger.log('🏢 [OTP] Storing userBusinesses - Count:', response.data.data.multiAccountList.length);
          logger.log('🏢 [OTP] Business list:', response.data.data.multiAccountList);
          localStorage.setItem(
            "userBusinesses",
            JSON.stringify(response.data.data.multiAccountList)
          );
          logger.log('🏢 [OTP] Stored in localStorage - userBusinesses set');
        } else {
          logger.warn('🏢 [OTP] No multiAccountList found or empty array');
        }

        if (response.data.data.userPreference) {
          Logger.log("[OTP] User preferences found, storing preferences");
          localStorage.setItem(
            "user_preferences",
            JSON.stringify(response.data.data.userPreference)
          );
          dispatch(userPreferences(response.data.data.userPreference));
          logger.log("🔑 OTP DISPATCH - Setting user preferences:", {
  timestamp: new Date().toISOString(),
  rawUserPreference: response.data.data.userPreference,
  hasCustomSource: !!response.data.data.userPreference?.customSource,
  customSourceCount: response.data.data.userPreference?.customSource?.length || 0,
  dispatchingToRedux: 'userPreferences'
});
          dispatch(
            setCustomSource(response.data.data.userPreference.customSource)
          );
        } else {
          Logger.log("[OTP] No user preferences in response");
        }

        dispatch(setUserDetails(response?.data?.data));
logger.log("🔑 OTP DISPATCH - Setting user details:", {
  timestamp: new Date().toISOString(),
  rawUserData: response?.data?.data,
  userDetailsType: Array.isArray(response?.data?.data) ? 'ARRAY' : 'OBJECT',
  dispatchingToRedux: 'setUserDetails'
});

        logger.log('🔍 DISPATCHED USER DETAILS:', response?.data?.data);
logger.log('🔍 DISPATCHED USER PREFERENCES:', response.data.data.userPreference);

        Logger.log("[OTP] Data stored in localStorage:", {
          token: localStorage.getItem("auth_token") ? "Present" : "Missing",
          userData: localStorage.getItem("userData") ? "Present" : "Missing",
          preferences: localStorage.getItem("user_preferences")
            ? "Present"
            : "Missing",
        });

        // Check user status conditions
        Logger.log("[OTP] Checking user status:", {
          isNewAccount: response?.data?.data?.isNewAccount,
          isOnboardCompleted: response?.data?.data?.isOnboardCompleted,
        });

        // New user OR incomplete onboarding -> straight to signup
        if (
          response?.data?.data?.isNewAccount ||
          !response?.data?.data?.isOnboardCompleted
        ) {
          Logger.log("[OTP] Redirecting to signup:", {
            reason: response?.data?.data?.isNewAccount
              ? "New User"
              : "Onboarding Incomplete",
          });
          navigate("/sign-up", { replace: true });
          return;
        }

        // Only check subscription for existing users with completed onboarding
  
        Logger.log("[OTP] Checking subscription status for existing user");
        if (!response?.data?.data?.isSubscriptionActive) {
          Logger.log("[OTP] Subscription inactive, redirecting to subscription expired page");
          setVerifyOtp(false);
          navigate("/SubscriptionExpiredPage", { replace: true });
          return;
        }

        // Success path - existing user, completed onboarding, active subscription
        Logger.log("[OTP] All checks passed");
        // if (response?.data?.data) {
        //   initHeapUser(response.data.data);
        // }

        // Check if user came here to setup/reset MPIN
        const shouldShowMpinSetup = localStorage.getItem("showMpinSetup") === "true";
        const mpinSetupType = localStorage.getItem("mpinSetupType");

        if (shouldShowMpinSetup && mpinSetupType) {
          Logger.log("[OTP] MPIN setup flow detected, redirecting to MPIN setup", {
            setupType: mpinSetupType
          });
          navigate("/mpin-setup", { replace: true });
          return;
        }

        // Regular login flow - clear any stale flags and navigate to leads
        localStorage.removeItem("showMpinSetup");
        localStorage.removeItem("mpinSetupType");
        Logger.log("[OTP] Regular login flow, navigating to leads");
        navigate("/leads", { replace: true });
      }
    } catch (err: any) {
      Logger.log("[OTP] Error occurred:", err);
      setVerifyOtp(false);
      
      // Check if the error indicates an expired free plan (403 status)
      if (err.response && err.response.status === 403 && err.response.data && 
          err.response.data.data && err.response.data.data.isFreePlan) {
        navigate("/SubscriptionExpiredPage", { replace: true });
      } else {
        toast.error("Error occurred while logging in!");
      }
    }
  }, [logId, navigate, otp, dispatch]);

  const resendOTP = async (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => {
  e.preventDefault();
  
  if (isButtonDisabled) {
    toast.error(`Please wait ${buttonCooldown} seconds before resending`);
    return;
  }
  
  const data = {
    phone: localStorage.getItem("phone"),
    countryCode: localStorage.getItem("countryCode"),
    otpType: "custom_sms_otp",
  };
  try {
    const response = await generateOtp(data);
    if (response && response.status) {
      toast.success("OTP Sent Successfully!");
      dispatch(setLogId(response?.data?.data?.LogID));
      startCooldown(); // Start 30-second cooldown
    }
  } catch (err) {
    toast.error("Error occured while sending OTP!");
  }
};

const getOtpOverWhatsApp = async () => {
  if (isButtonDisabled) {
    toast.error(`Please wait ${buttonCooldown} seconds before sending WhatsApp OTP`);
    return;
  }
  
  const data = {
    phone: localStorage.getItem("phone"),
    countryCode: localStorage.getItem("countryCode"),
    otpType: "custom_whatsapp_otp",
  };
  try {
    const response = await generateOtp(data);
    if (response && response.status) {
      toast.success(response?.data?.message);
      dispatch(setLogId(response?.data?.data?.LogID));
      startCooldown(); // Start 30-second cooldown
    }
  } catch (err) {
    toast.error("Error occured while sending OTP!");
  }
};

  const handleChange = (otp: React.SetStateAction<string>) => {
    setOTP(otp);
  };

  useEffect(() => {
    if (otp && otp.length === 4) {
      handleClick();
    }
  }, [handleClick, otp]);

  const editPhoneNumber = () => {
    navigate("/", { replace: true });
  };

  // Show MPIN setup if flag is set after successful login
  if (showMpinSetup) {
    Logger.log("[OTP] Rendering PostLoginMpinSetup component");
    return <PostLoginMpinSetup />;
  }

  return (
    <div className="onboarding-container">
      <div className="onboarding-card">
        {/* Logo */}
        <div className="onboarding-logo">
          <img src="assets/img/3sigma_logo.png" alt="3Sigma CRM" />
        </div>

        {/* Header */}
        <div className="onboarding-header">
          <h2>Verify Your Phone</h2>
          <p className="onboarding-subtitle">
            We sent a code to <span className="phone-number-display">+{localStorage.getItem("countryCode")} {localStorage.getItem("phone")}</span>
          </p>
          <button
            onClick={editPhoneNumber}
            className="change-number-btn"
          >
            Change Number
          </button>
        </div>

        {/* OTP Input */}
        <form className="onboarding-form">
          <div className="otp-input-wrapper">
            <OtpInput
              value={otp}
              onChange={handleChange}
              numInputs={4}
              isInputNum
              separator={<span style={{ width: "12px" }}></span>}
              shouldAutoFocus={true}
              containerStyle={{
                display: "flex",
                justifyContent: "space-between",
                gap: "12px",
              }}
            />
          </div>

          {otp_verify_error && (
            <p className="onboarding-error-text" style={{ textAlign: "center", marginBottom: "16px" }}>
              Invalid OTP. Please try again.
            </p>
          )}

          <button
            type="button"
            className="onboarding-btn-primary"
            onClick={handleClick}
            disabled={verifying_otp}
          >
            {verifying_otp ? (
              <span className="onboarding-loading">
                <span className="onboarding-spinner"></span>
                Verifying...
              </span>
            ) : (
              "Verify OTP"
            )}
          </button>
        </form>

        {/* Resend Options */}
        <div style={{ marginTop: "32px", textAlign: "center" }}>
          {!flag ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
              <span className="timer-text">
                Resend OTP in{" "}
                <span className="timer-countdown">
                  <Timer seconds={seconds} />
                </span>
              </span>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", alignItems: "center" }}>
              <p className="timer-text" style={{ marginBottom: "8px" }}>
                Didn't receive the code?
              </p>
              <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "center" }}>
                <button
                  onClick={(e) => resendOTP(e)}
                  disabled={isButtonDisabled}
                  style={{
                    padding: "10px 20px",
                    background: isButtonDisabled ? "#f1f5f9" : "#ecf4fe",
                    color: isButtonDisabled ? "#94a3b8" : "#0056fe",
                    border: `2px solid ${isButtonDisabled ? "#e2e8f0" : "#0056fe"}`,
                    borderRadius: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: isButtonDisabled ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                    opacity: isButtonDisabled ? 0.6 : 1,
                  }}
                >
                  {isButtonDisabled ? `Resend SMS (${buttonCooldown}s)` : "Resend SMS"}
                </button>
                <button
                  onClick={() => getOtpOverWhatsApp()}
                  disabled={isButtonDisabled}
                  style={{
                    padding: "10px 20px",
                    background: isButtonDisabled ? "#f1f5f9" : "rgba(16, 185, 129, 0.1)",
                    color: isButtonDisabled ? "#94a3b8" : "#10b981",
                    border: `2px solid ${isButtonDisabled ? "#e2e8f0" : "#10b981"}`,
                    borderRadius: "10px",
                    fontSize: "14px",
                    fontWeight: "600",
                    cursor: isButtonDisabled ? "not-allowed" : "pointer",
                    transition: "all 0.2s ease",
                    opacity: isButtonDisabled ? 0.6 : 1,
                  }}
                >
                  {isButtonDisabled ? `WhatsApp (${buttonCooldown}s)` : "Send via WhatsApp"}
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="onboarding-footer">
          <p className="onboarding-footer-text">
            By continuing, you agree to our{" "}
            <a
              href="https://www.3sigmacrm.com/terms-of-use"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>{" "}
            and{" "}
            <a
              href="https://www.3sigmacrm.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};